module.exports = __webpack_public_path__ + "media/images/category_icons/tutorial-e939e642f010ad9c2690216a3cc4ba8c.svg";